import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Spinner from '../../components/Spinner/Spinner';
import useFetch from '../../hooks/useFetch';
import './targetsoverview.scss';
import Modal from '../../components/Modal/Modal';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';
import { ReactComponent as Pen } from '../../assets/edit.svg';
import { ReactComponent as BackIcon } from '../../assets/backIcon.svg';
// import base from '../../apis';

function TargetsOverview() {
  // const [searchParams, setSearchParams] = useState(second)
  const [modalOpen, setModalOpen] = useState(false);
  const [modalState, setModalState] = useState(1);
  const [selectedTarget, setSelectedTarget] = useState(null);
  const { data: targets, isLoading, error } = useFetch('/operations/sales_targets/');
  // const { data: subs, error: subsError } = useFetch('/register/list_products/');
  const [subs] = useState([
    { label: 'BPO Farm', value: 'bpo-farm' },
    { label: 'BPO Premier Agent', value: 'premier-agent-website' },
    { label: 'Deal Analyzer', value: 'deal-analyzer' },
    { label: 'Combo Package', value: 'combo-package' },
  ]);

  useEffect(() => {
    if (error) {
      toast.error('Could not get targets', { toastId: 'error' });
    }
  }, [error]);
  useEffect(() => {
    if (targets?.length === 0) {
      toast.error('No targets found', { toastId: 'error' });
    }
  }, [targets]);

  const navigate = useNavigate();
  const [selectedSubTarget, setSelectedSubTarget] = useState(null);
  const setSelectedSub = (sub) => {
    setModalState(2);
    setSelectedSubTarget(sub);
  };

  const onSelectTarget = (target) => {
    setSelectedTarget(target);
    setModalState(1);
    setModalOpen(true);
  };
  return (
    <>
      {isLoading && <Spinner />}
      {/* <ConfirmationModal text='Are you sure you want to delete this target?'/> */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        {modalState === 1 && (
          <div className="aomodal-1">
            <div className="modheader">
              <p style={{ textTransform: 'capitalize' }}>
                {selectedTarget && new Date(selectedTarget?.date_due).getFullYear()} <span>{'>'}</span>{' '}
                {selectedTarget?.period}
              </p>
              <CloseIcon
                onClick={() => setModalOpen(false)}
                style={{ fill: 'black', cursor: 'pointer', transform: 'scale(.8)' }}
              />
            </div>
            <div className="modcontent">
              <div
                className="edit_wrapper"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(`set/${selectedTarget?.id}`)}>
                <Pen style={{ transform: 'scale(.5)' }} /> <p>Edit</p>
              </div>
              <h3>{selectedTarget?.title}</h3>
              <div className="target_details">
                <div className="target_details_column">
                  <p>Owner</p>
                  <p>{selectedTarget?.owner}</p>
                </div>
                <div className="target_details_column">
                  <p>Target Period</p>
                  <p style={{ textTransform: 'capitalize' }}>{selectedTarget?.period}</p>
                </div>
                <div className="target_details_column">
                  <p>Date</p>
                  <p>
                    {selectedTarget?.period === 'monthly'
                      ? new Date(selectedTarget?.date_due).toLocaleDateString('en', { month: 'long', year: 'numeric' })
                      : new Date(selectedTarget?.date_due).toLocaleDateString('en', { year: 'numeric' })}
                  </p>
                </div>
                <div className="target_details_column">
                  <p>Target Amount</p>
                  <p>$ {Number(selectedTarget?.amount).toLocaleString()}</p>
                </div>
              </div>
              <div className="target_details">
                <div className="target_details_column">
                  <p>Target Amount</p>
                  <p>$ {Number(selectedTarget?.amount_per_team).toLocaleString()} / Team</p>
                </div>
              </div>

              {selectedTarget?.sub_targets.length > 0 && (
                <>
                  <div className="sub_targets">
                    <p>{`${selectedTarget?.sub_targets?.length} Sub target${
                      selectedTarget?.sub_targets?.length >= 1 ? 's' : ''
                    }`}</p>
                  </div>
                  <div className="sub_target_details">
                    {selectedTarget?.sub_targets?.map((sub, index) => (
                      <div key={sub.id} className="target_info_details">
                        <div className="dot"></div>
                        <p
                          onClick={() => {
                            setSelectedSub(sub);
                          }}>
                          {subs?.find((item) => item.value === sub.package_name)?.label}
                        </p>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        )}
        {modalState === 2 && (
          <div className="aomodal-2">
            <div className="modheader">
              <p>
                <BackIcon fill="black" onClick={() => setModalState(1)} style={{ cursor: 'pointer' }} />
                {subs?.find((item) => item.id === selectedSubTarget.id)?.title}
              </p>
              <CloseIcon onClick={() => setModalOpen(false)} style={{ fill: 'black', cursor: 'pointer' }} />
            </div>
            <div className="modcontent">
              <div className="target_time">
                <p>Year</p>
                <p className="text_grey">{'>'}</p>
                <p style={{ textTransform: 'capitalize' }}>{selectedTarget?.period}</p>
              </div>
              <div className="sub_targetholder">
                <h2 className="sub_target_name">{subs?.find((item) => item.id === selectedSubTarget?.id)?.title}</h2>
                <div className="target_details">
                  <div className="target_details_column">
                    <p>Points Per Subscription</p>
                    <p>{selectedSubTarget?.points_per_sub} Points/Subscription</p>
                  </div>
                  <div className="target_details_column">
                    <p>Targeted Amount</p>
                    <p>$ &nbsp;&nbsp;{Number(selectedSubTarget?.amount).toLocaleString()}</p>
                  </div>
                  <div className="target_details_column">
                    <p>Amount Per Team</p>
                    <p>$ &nbsp;&nbsp;{Number(selectedSubTarget?.amount_per_team).toLocaleString()} /Team</p>
                  </div>
                </div>
                <div className="target_details">
                  <div className="target_details_column">
                    <p>Percentage Share</p>
                    <span className="grey_text">The percentage the Sub Target covers</span>
                    <p>{Number(selectedSubTarget?.percent_share) * 100}% of the year/month/week</p>
                  </div>
                </div>
                {selectedSubTarget?.bonus === 1 && (
                  <div className="target_details">
                    <div className="target_details_column">
                      <p>Bonus</p>
                      <p className="grey_text">Number of subscriptions to qualify for a bonus</p>
                      <p>{selectedSubTarget?.subs_for_bonus} subscriptions</p>
                    </div>
                    <div className="target_details_column">
                      <p>Points</p>
                      <p className="grey_text">Number of points to qualify for a bonus</p>
                      <p>{selectedSubTarget?.points_for_bonus} points</p>
                    </div>
                    <div className="target_details_column">
                      <p>Commission</p>
                      <p className="grey_text">How much the bonus attracts</p>
                      <p>$ {Number(selectedSubTarget?.commission)}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </Modal>
      <div className="targetsoverview">
        {/* <form className="modinputs" onSubmit={(e) => e.preventDefault()}>
          <Input
            placeholder="Enter Office Name"
            type="search"
            name="name"
            style={{ fontSize: '18px', padding: '10px 20px' }}
          />
          <Input
            placeholder="Enter City"
            type="search"
            name="city"
            style={{ fontSize: '18px', padding: '10px 20px' }}
          />
          <Input
            placeholder="Enter State"
            type="search"
            name="state"
            style={{ fontSize: '18px', padding: '10px 20px' }}
          />
          <Input
            placeholder="Enter Office Address"
            type="search"
            name="address"
            style={{ fontSize: '18px', padding: '10px 20px' }}
          />
          <Button
            style={{
              width: '100px',
              fontSize: '18px',
              padding: '10px',
              color: 'white',
              backgroundColor: 'var(--primary-color)',
              display: 'block',
            }}
            type="submit"
            text="Filter"
            // onClick={}
          />
        </form> */}
        <div className="targetsoverview_header">
          <h4>TARGETS</h4>
          <NavLink to="set" className="toNew">
            + ADD TARGET
          </NavLink>
        </div>
        <div className="targetsoverview_holder">
          {targets?.map((target) => (
            <div className="targetsoverview_content" onClick={() => onSelectTarget(target)} key={target.id}>
              <div>
                <div className="targetsoverview_content-row">
                  <h3>{target.title}</h3>
                  <h4>{`${target.sub_targets?.length} Sub target${target.sub_targets?.length >= 1 ? 's' : ''}`} </h4>
                  {/* <MdDeleteForever
                    // onClick={}
                    title="Delete Sub target"
                    className="bin"
                  /> */}
                </div>
                <span className="lig">{`${new Date(target.date_due).getFullYear()}${
                  target.period === 'monthly'
                    ? ' ' + new Date(target.date_due).toLocaleDateString('en', { month: 'long' })
                    : ''
                } / ${target.period} `}</span>
              </div>
              <div>
                <div>
                  <span></span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default TargetsOverview;
